import { render } from "./ChromeSettingsIcon.vue?vue&type=template&id=91150242&ts=true"
import script from "./ChromeSettingsIcon.vue?vue&type=script&lang=ts"
export * from "./ChromeSettingsIcon.vue?vue&type=script&lang=ts"

import "./ChromeSettingsIcon.vue?vue&type=style&index=0&id=91150242&lang=css"

import exportComponent from "/builds/knx-core/freightbox/freightbox-monorepo-vue/services/eleos-driver-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__